import {Owner} from 'auth/PermissionConstants';
import {isBrowser} from 'lib/Browser';
import EntityStore from 'stores/EntityStore';

export function stringify(schemaSpec: object): string {
  return JSON.stringify(schemaSpec, null, 4);
}

export function getSchemaOwnerChoices(): Array<Owner> {
  return isBrowser && EntityStore.currentUser() ? EntityStore.currentUser().organizations : [];
}
